import React from "react";

export function LogoutIcon({ color = "white" }: { color?: string }) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 0C15.2794 0 15.9204 0.59514 15.9931 1.35558L16 1.5V13.5C16 14.2794 15.4049 14.9204 14.6444 14.9931L14.5 15H7.5C6.72057 15 6.07958 14.4049 6.00687 13.6444L6 13.5V10.5C6 10.2239 6.22386 10 6.5 10C6.74546 10 6.94961 10.1769 6.99194 10.4101L7 10.5V13.5C7 13.7452 7.1771 13.9496 7.4102 13.9919L7.5 14H14.5C14.7452 14 14.9496 13.8229 14.9919 13.5898L15 13.5V1.5C15 1.25479 14.8229 1.05045 14.5898 1.00807L14.5 1H7.5C7.25479 1 7.05045 1.1771 7.00807 1.4102L7 1.5V4.5C7 4.77614 6.77614 5 6.5 5C6.25454 5 6.05039 4.82312 6.00806 4.58988L6 4.5V1.5C6 0.720572 6.59514 0.0795828 7.35558 0.00686932L7.5 0H14.5ZM3.85355 4.14645C4.02712 4.32001 4.0464 4.58944 3.91141 4.78431L3.85355 4.85355L1.706 7H11.5C11.7761 7 12 7.22386 12 7.5C12 7.74546 11.8231 7.94961 11.5899 7.99194L11.5 8H1.706L3.85355 10.1464C4.02712 10.32 4.0464 10.5894 3.91141 10.7843L3.85355 10.8536C3.67999 11.0271 3.41056 11.0464 3.21569 10.9114L3.14645 10.8536L0.146447 7.85355L0.134589 7.84129C0.122939 7.82882 0.11192 7.81575 0.101583 7.80214L0.146447 7.85355C0.119612 7.82672 0.0964656 7.79759 0.0770068 7.76681C0.0700191 7.75568 0.0632935 7.74405 0.0570345 7.73213C0.0497498 7.71828 0.0433514 7.70454 0.0376105 7.69059C0.0324084 7.67802 0.0275579 7.66474 0.0232682 7.6512C0.0184478 7.63583 0.014396 7.62047 0.0110855 7.60499C0.00889152 7.59495 0.00700655 7.58456 0.00544786 7.57407C0.00238729 7.55324 0.000611181 7.5324 0.000132561 7.51154C4.24007e-05 7.50757 0 7.50379 0 7.5L0.000110149 7.48946C0.000554149 7.46827 0.00233802 7.44709 0.00546169 7.42608L0 7.5C0 7.4639 0.00382511 7.4287 0.0110922 7.39477C0.0143961 7.37953 0.0184482 7.36417 0.0232415 7.34899C0.0275583 7.33526 0.0324084 7.32198 0.0377922 7.30896C0.0433514 7.29546 0.0497498 7.28172 0.0568051 7.26824C0.0632935 7.25595 0.0700193 7.24432 0.077188 7.23299C0.0807332 7.2273 0.0845945 7.22146 0.0885911 7.21569L0.101583 7.19786C0.11192 7.18425 0.122939 7.17118 0.134589 7.15871L0.146447 7.14645L3.14645 4.14645C3.34171 3.95118 3.65829 3.95118 3.85355 4.14645Z"
        fill={color}
      />
    </svg>
  );
}

export function ComponentLibraryIcon({ color = "white" }: { color?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 16C3.22386 16 3 15.7761 3 15.5V11.5C3 11.2239 3.22386 11 3.5 11H15.5C15.7761 11 16 11.2239 16 11.5V15.5C16 15.7761 15.7761 16 15.5 16H3.5ZM12 12H4V15H12V12ZM15 12H13V15H15V12ZM12.5 6C12.7761 6 13 6.22386 13 6.5V9.5C13 9.77614 12.7761 10 12.5 10H0.5C0.223858 10 0 9.77614 0 9.5V6.5C0 6.22386 0.223858 6 0.5 6H12.5ZM9 7H1V9H9V7ZM12 7H10V9H12V7ZM15.5 0C15.7761 0 16 0.223858 16 0.5V4.5C16 4.77614 15.7761 5 15.5 5H3.5C3.22386 5 3 4.77614 3 4.5V0.5C3 0.223858 3.22386 0 3.5 0H15.5ZM12 1H4V4H12V1ZM15 1H13V4H15V1Z"
        fill={color}
      />
    </svg>
  );
}

export function DashboardIcon({ color = "white" }: { color?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 11C6.77614 11 7 11.2239 7 11.5V15.5C7 15.7761 6.77614 16 6.5 16H0.5C0.223858 16 0 15.7761 0 15.5V11.5C0 11.2239 0.223858 11 0.5 11H6.5ZM15.5 8C15.7761 8 16 8.22386 16 8.5V15.5C16 15.7761 15.7761 16 15.5 16H9.5C9.22386 16 9 15.7761 9 15.5V8.5C9 8.22386 9.22386 8 9.5 8H15.5ZM6 12H1V15H6V12ZM15 9H10V15H15V9ZM6.5 0C6.77614 0 7 0.223858 7 0.5V8.5C7 8.77614 6.77614 9 6.5 9H0.5C0.223858 9 0 8.77614 0 8.5V0.5C0 0.223858 0.223858 0 0.5 0H6.5ZM6 1H1V8H6V1ZM15.5 0C15.7761 0 16 0.223858 16 0.5V5.5C16 5.77614 15.7761 6 15.5 6H9.5C9.22386 6 9 5.77614 9 5.5V0.5C9 0.223858 9.22386 0 9.5 0H15.5ZM15 1H10V5H15V1Z"
        fill={color}
      />
    </svg>
  );
}

export function NotificationsIcon({ color = "white" }: { color?: string }) {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 0C0.74546 0 0.949608 0.176875 0.991944 0.410124L1 0.5V15.5C1 15.7761 0.776142 16 0.5 16C0.25454 16 0.0503916 15.8231 0.00805569 15.5899L0 15.5V0.5C0 0.223858 0.223858 0 0.5 0ZM12.5 2C12.7761 2 13 2.22386 13 2.5V9.5C13 9.77614 12.7761 10 12.5 10H3.5C3.22386 10 3 9.77614 3 9.5V2.5C3 2.22386 3.22386 2 3.5 2H12.5ZM12 3H4V9H12V3Z"
        fill={color}
      />
    </svg>
  );
}

export function ProductsIcon({ color = "white" }: { color?: string }) {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.30304 0.0404275C7.42881 -0.0134758 7.57119 -0.0134758 7.69696 0.0404275L14.697 3.04043C14.7015 3.04238 14.706 3.04439 14.7105 3.04647C14.7248 3.05307 14.7393 3.06064 14.7534 3.06891C14.7626 3.07435 14.7714 3.07995 14.7801 3.0858C14.7955 3.09611 14.8102 3.10731 14.8244 3.11935C14.8322 3.12617 14.84 3.1332 14.8475 3.14045C14.858 3.15039 14.8685 3.16145 14.8785 3.17304C14.8884 3.18479 14.8977 3.19661 14.9065 3.20882C14.9132 3.218 14.9196 3.22771 14.9258 3.2377C14.9358 3.25411 14.9448 3.27079 14.9528 3.28796C14.955 3.29252 14.9573 3.29775 14.9596 3.30304L14.9641 3.31382C14.9709 3.33077 14.9768 3.34814 14.9817 3.36585L14.9596 3.30304C14.9739 3.33643 14.9843 3.37051 14.991 3.40477C14.9969 3.4355 15 3.4675 15 3.5L14.9971 3.44475C14.9986 3.45845 14.9995 3.47215 14.9999 3.48581L15 3.5V12.5C15 12.7 14.8808 12.8808 14.697 12.9596L7.69696 15.9596C7.69337 15.9611 7.68976 15.9626 7.68614 15.9641C7.67484 15.9687 7.6636 15.9728 7.65218 15.9764C7.63495 15.9818 7.61744 15.9863 7.59978 15.9899C7.59119 15.9918 7.58217 15.9934 7.57307 15.9947C7.55527 15.9972 7.53783 15.9989 7.52036 15.9996C7.51376 15.9999 7.5069 16 7.5 16L7.48064 15.9996C7.46249 15.9989 7.44438 15.9972 7.42638 15.9946L7.5 16C7.46571 16 7.43222 15.9965 7.39987 15.99C7.36713 15.9832 7.33456 15.9731 7.30304 15.9596L7.34782 15.9764C7.3364 15.9728 7.32516 15.9687 7.31411 15.9643L7.30304 15.9596L0.303041 12.9596C0.119199 12.8808 0 12.7 0 12.5V3.5C0 3.49765 1.66811e-05 3.4953 4.95911e-05 3.49295C0.000123871 3.47555 0.00135602 3.45715 0.00363541 3.43875C0.00523462 3.42682 0.00703422 3.41554 0.00920868 3.40437C0.0115436 3.39196 0.0145608 3.37917 0.0181079 3.36644C0.0232418 3.34814 0.0291342 3.33077 0.0359387 3.31382C0.0373461 3.31035 0.0388636 3.30669 0.0404277 3.30304L0.0471797 3.28796C0.055222 3.27079 0.0642257 3.25411 0.0741377 3.238L0.0404277 3.30304C0.0550025 3.26903 0.072901 3.23747 0.0935822 3.20857C0.102277 3.19661 0.111573 3.18479 0.121394 3.1734C0.131548 3.16145 0.142038 3.15039 0.152968 3.13986C0.160027 3.1332 0.167766 3.12617 0.175735 3.11938C0.189779 3.10731 0.204549 3.09611 0.219854 3.08578C0.245806 3.06828 0.273594 3.05305 0.303041 3.04043L0.246631 3.06891C0.260725 3.06064 0.275204 3.05307 0.290009 3.04623L0.303041 3.04043L7.30304 0.0404275ZM1 4.258V12.17L7 14.742V6.829L1 4.258ZM14 4.257L8 6.829V14.742L14 12.17V4.257ZM7.5 1.043L1.768 3.499L7.5 5.956L13.232 3.499L7.5 1.043Z"
        fill={color}
      />
    </svg>
  );
}

export function ProgramsIcon({ color = "white" }: { color?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 11C15.7761 11 16 11.2239 16 11.5V15.5C16 15.7761 15.7761 16 15.5 16H11.5C11.2239 16 11 15.7761 11 15.5V11.5C11 11.2239 11.2239 11 11.5 11H15.5ZM15 12H12V15H15V12ZM2.5 6C2.74546 6 2.94961 6.17688 2.99194 6.41012L3 6.5V11.5C3 12.2797 3.59489 12.9204 4.35554 12.9931L4.5 13H9.5C9.77614 13 10 13.2239 10 13.5C10 13.7455 9.82312 13.9496 9.58988 13.9919L9.5 14H4.5C3.17452 14 2.08996 12.9685 2.00532 11.6644L2 11.5V6.5C2 6.22386 2.22386 6 2.5 6ZM11.5 2C12.8255 2 13.91 3.03154 13.9947 4.33562L14 4.5V9.5C14 9.77614 13.7761 10 13.5 10C13.2545 10 13.0504 9.82312 13.0081 9.58988L13 9.5V4.5C13 3.7203 12.4051 3.07955 11.6445 3.00687L11.5 3H6.5C6.22386 3 6 2.77614 6 2.5C6 2.25454 6.17688 2.05039 6.41012 2.00806L6.5 2H11.5ZM4.5 0C4.77614 0 5 0.223858 5 0.5V4.5C5 4.77614 4.77614 5 4.5 5H0.5C0.223858 5 0 4.77614 0 4.5V0.5C0 0.223858 0.223858 0 0.5 0H4.5ZM4 1H1V4H4V1Z"
        fill={color}
      />
    </svg>
  );
}

export function SettingsIcon({ color = "white" }: { color?: string }) {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 0C11.6736 0 11.8348 0.0900775 11.9258 0.237951L15.9258 6.73795C16.0247 6.89865 16.0247 7.10135 15.9258 7.26205L11.9258 13.762C11.8348 13.9099 11.6736 14 11.5 14H4.5C4.32637 14 4.16517 13.9099 4.07417 13.762L0.0741708 7.26205C-0.0247236 7.10135 -0.0247236 6.89865 0.0741708 6.73795L4.07417 0.237951C4.16517 0.0900775 4.32637 0 4.5 0H11.5ZM11.22 1H4.779L1.087 7L4.779 13H11.22L14.912 7L11.22 1ZM8 4C9.65685 4 11 5.34315 11 7C11 8.65685 9.65685 10 8 10C6.34315 10 5 8.65685 5 7C5 5.34315 6.34315 4 8 4ZM8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5Z"
        fill={color}
      />
    </svg>
  );
}
